function onIntersection(elements, observer) {
  // motion-delay-xxxx classes are set in tw.base.css
  const maxDelay = 2000;
  const delayIncrement = 25
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (!elementTarget.classList.contains('played-scroll-animation')) {
        elementTarget.classList.add('played-scroll-animation');
        elementTarget.getAttribute('data-scroll-animations').split(' ').forEach(anim => {
          elementTarget.classList.add(anim);
        });
        const dataDelay = elementTarget.getAttribute("data-scroll-animations-delay");
        if (dataDelay && dataDelay < maxDelay && dataDelay % delayIncrement == 0) {
          elementTarget.classList.add(`motion-delay-${dataDelay}`)
        }
        else {
          const delay = (index % (maxDelay / delayIncrement)) * delayIncrement;
          elementTarget.classList.add(`motion-delay-${delay}`);
        }
      }
      observer.unobserve(elementTarget);
    }
  });
}

const initializeScrollAnimationTrigger = () => {
  const animationTriggerElements = Array.from(document.querySelectorAll('[data-scroll-animations]'));
  if (animationTriggerElements.length === 0 || Shopify.designMode) return;
  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -75px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
});